import { MessageResponse } from "../../../../src/api/common";
import ParticipantsAPI, { AddParticipantRequest, AddParticipantResponse, UpdateParticipantRequest } from "../../../../src/api/participants";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const addParticipant = createAsyncThunk<
  AddParticipantResponse,
  { caseId: string; request: AddParticipantRequest },
  { rejectValue: string }
>(
  "cases/addParticipant",
  async ({ caseId, request }, { rejectWithValue }) => {
    try {
      const response = await ParticipantsAPI.addParticipant(caseId, request);
      return response; 
    } catch (error: any) {
      const errorMessage =error.response?.data?.message || "An unexpected error occurred. Please try again.";
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateParticipant = createAsyncThunk<
   MessageResponse,
  { caseId: string; participationId: string; request: UpdateParticipantRequest },
  { rejectValue: string }
>(
  "cases/updateParticipant",
  async (
    { caseId, participationId, request },
    { rejectWithValue }
  ) => {
    try {
       return await ParticipantsAPI.updateParticipant(caseId, participationId, request);
    } catch (error: any) {
      const errorMessage =error.response?.data?.message ||"An unexpected error occurred. Please try again.";
      return rejectWithValue(errorMessage);
    }
  }
);